/**
 * The FIT CRC-16. Not CRC-16-ANSI: it is a nibble-table variant defined by the FIT
 * protocol, processing the low nibble of each byte before the high nibble, init 0.
 */
const CRC_TABLE = [
  0x0000, 0xcc01, 0xd801, 0x1400, 0xf001, 0x3c00, 0x2800, 0xe401, 0xa001, 0x6c00, 0x7800, 0xb401,
  0x5000, 0x9c01, 0x8801, 0x4400,
]

export function crc16(data: Uint8Array, seed = 0): number {
  let crc = seed
  for (let i = 0; i < data.length; i++) {
    const byte = data[i]!
    // low nibble, then high nibble
    let tmp = CRC_TABLE[crc & 0xf]!
    crc = ((crc >> 4) & 0x0fff) ^ tmp ^ CRC_TABLE[byte & 0xf]!
    tmp = CRC_TABLE[crc & 0xf]!
    crc = ((crc >> 4) & 0x0fff) ^ tmp ^ CRC_TABLE[(byte >> 4) & 0xf]!
  }
  return crc & 0xffff
}
